import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import './Home.css';
import { ReviewBlock } from './ReviewBlock';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    const orgSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "ho.li design GmbH",
      "url": "https://holidesign.de",
      "logo": "https://holidesign.de/imgs/labelprint_grey_large.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@holidesign.de",
        "contactType": "customer service",
        "availableLanguage": "German"
      }
    };
    const items = [
      {
        imgSrc: "https://saholiprod2.blob.core.windows.net/sc-holi-prod2/pouf-boucle-white-scene.jpeg",
        alt: "Das Foto zeigt den ho.li Pouf BROOKLYN white in einem Wohnzimmer.",
        title: "Unsere ho.li Poufs für drinnen und draußen",
        description: `<p>Du bist auf der Suche nach einem gemütlichen Sitzsack für euer Zuhause oder euren Garten? Dann seid ihr bei uns genau richtig! In verschiedenen Farben und Stoffen, sowie zwei unterschiedlichen Größen, können unsere Poufs vielfältig als Sitzgelegenheit, Fußablage oder einfach als Deko-Element genutzt werden.</p>
        <p>Unsere Poufs sind nicht nur bequem, sondern auch stylisch und passen perfekt in jedes Zuhause. Egal ob im Wohnzimmer, Schlafzimmer oder im Garten – sie sind die perfekte Ergänzung für jeden Raum.</p>
        <p>Seit Kurzem haben wir auch unsere Outdoor Poufs online gestellt. Schaut euch doch einfach um!</p>`,
      },
      {
        imgSrc: "https://saholiprod2.blob.core.windows.net/sc-holi-prod2/fabric.jpeg",
        alt: "Das Foto zeigt die verschiedenen Stoffe sowie die Nähte der ho.li Poufs.",
        title: "Hochwertige Bezüge mit doppelten Nähten",
        description: ` 
          <p>Unsere Bezüge sind aus hochwertigen und strapazierfähigen Stoffen gemacht, die nicht nur gut aussehen, sondern auch lange halten. Dank der doppelten Nähte sind sie besonders robust und haben ein schickes Design.</p>
          <p>Momentan haben wir drei verschiedene Stoffe im Angebot: </p>
          <p><strong>BROOKLYN</strong>: Ein weicher Bouclé-Stoff, perfekt für drinnen.<br />
          <strong>QUEENS</strong>: Ein Stoff mit Leinen-Optik, ebenfalls ideal für den Innenbereich.<br />
          <strong>MANHATTAN</strong>: Ein robuster und wasserabweisender Stoff, der sich super für draußen eignet.</p>`
      },
      {
        imgSrc: "https://saholiprod2.blob.core.windows.net/sc-holi-prod2/inlay2.jpeg",
        alt: "Das Foto zeigt den integrierten Wäschesack sowie den Reißverschluss an der Unterseite des ho.li Poufs.",
        title: "Praktischer Wäschesack für einfache Pflege",
        description: `<p>Dank des integrierten Wäschesacks kannst du das Füllmaterial einfach umfüllen und den Bezug in der Maschine waschen. Außerdem macht der Wäschesack das Auffüllen oder Austauschen der Füllung kinderleicht, falls der Pouf mal über die Zeit an Volumen verlieren sollte. <br />Mit dem integrierten Wäschesack und dem Reißverschluss an der Unterseite bleibt jede EPS-Perle sicher im Pouf.</p>`,
      },
      {
        imgSrc: "https://saholiprod2.blob.core.windows.net/sc-holi-prod2/eps.jpg",
        alt: "Das Foto zeigt die EPS-Perlen, die in den ho.li Poufs verwendet werden.",
        title: "Perfekte Form dank hochwertiger EPS-Perlen",
        description: `<p>Unsere Poufs sind mit in Deutschland hergestellten EPS-Perlen gefüllt. Wir haben bewusst etwas schwerere Perlen gewählt, um ein angenehmes Gewicht und eine schöne Form zu gewährleisten.</p>`,
      }
    ];

    return (
      <div style={{ marginBottom: '60px' }}>
        <Helmet>
          <title>Pouf kaufen – Sitzsäcke für drinnen & draußen | ho.li design</title>
          <meta name="description" content="Entdecke ho.li Poufs – handgefertigte Sitzsäcke aus Bouclé, Leinen & Outdoor-Stoff. Für Wohnzimmer & Garten, in 2 Größen, waschbar. Jetzt online kaufen." />
          <meta name="keywords" content="Pouf kaufen, Sitzsack kaufen, Sitzsack Wohnzimmer, Outdoor Pouf, Bouclé Sitzsack, Pouf Leinen, ho.li design" />
          <meta name="language" content="de" />
          <link rel="canonical" href="https://holidesign.de/" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Pouf kaufen – Sitzsäcke für drinnen & draußen | ho.li design" />
          <meta property="og:description" content="Entdecke ho.li Poufs – handgefertigte Sitzsäcke aus Bouclé, Leinen & Outdoor-Stoff. Für Wohnzimmer & Garten, in 2 Größen, waschbar. Jetzt online kaufen." />
          <meta property="og:url" content="https://holidesign.de/" />
          <meta property="og:image" content="https://saholiprod2.blob.core.windows.net/sc-holi-prod2/inscene.jpeg" />
          <meta property="og:site_name" content="ho.li design" />
          <meta property="og:locale" content="de_DE" />
          <meta name="twitter:card" content="summary_large_image" />
          <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
        </Helmet>
        <h1 style={{ marginBottom: '40px' }}>Willkommen bei ho.li design</h1>
        <div className="home-container">
          {items.map((item, index) => (
            <div
              key={index}
              className={`home-content ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
            >
              <img src={item.imgSrc} alt={item.alt} title={item.title} className="home-image" />
              <div className="home-text">
                <p><strong>{item.title}</strong></p>
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          ))}
        </div>
        <ReviewBlock />
      </div>
    );
  }
}
